import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const CheckboxMultipleOutline = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 14 14'
    >
      <path
        d='M12 0H4C3.64638 0 3.30724 0.140476 3.05719 0.390524C2.80714 0.640573 2.66667 0.979711 2.66667 1.33333V9.33333C2.66667 9.68695 2.80714 10.0261 3.05719 10.2761C3.30724 10.5262 3.64638 10.6667 4 10.6667H12C12.3536 10.6667 12.6928 10.5262 12.9428 10.2761C13.1929 10.0261 13.3333 9.68695 13.3333 9.33333V1.33333C13.3333 0.979711 13.1929 0.640573 12.9428 0.390524C12.6928 0.140476 12.3536 0 12 0ZM12 9.33333H4V1.33333H12V9.33333ZM9.33333 12V13.3333H1.33333C0.979711 13.3333 0.640573 13.1929 0.390524 12.9428C0.140476 12.6928 0 12.3536 0 12V3.33333H1.33333V12H9.33333ZM11.02 4.04L10.3133 3.33333L7.06 6.58667L5.64667 5.17333L4.94 5.88L7.06 8L11.02 4.04Z'
        fill='#F8F8F8'
      />
    </SvgIcon>
  );
};
export default CheckboxMultipleOutline;
